module.exports = __webpack_public_path__ + "img/02.ca19740e.png";